import { render, staticRenderFns } from "./MessageFormModal.vue?vue&type=template&id=fffb15a0"
import script from "./MessageFormModal.vue?vue&type=script&lang=js"
export * from "./MessageFormModal.vue?vue&type=script&lang=js"
import style0 from "./MessageFormModal.vue?vue&type=style&index=0&id=fffb15a0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports